<template>
  <div class="container">
    <app-header title="我的发票信息"/>
    <div class="main">
      <div class="title">选择开票信息</div>
      <van-radio-group v-model="activeCoupon" @change="changeItem">

        <div class="item" v-for="(item) in ticketList" :key='item.id'>
          <div class="name" v-if="item.type==0">增值税专票</div>
          <div class="name" v-if="item.type==1">普通发票</div>
          <div class="address">
            <div class="text">发票抬头</div>
            <div class="content">{{item.companyName}}</div>
          </div>
          <div class="orderNo">
            <div class="text">税号</div>
            <div class="content">{{item.code}}</div>
            <van-radio :name="item.id" checked-color="#FE003B" @click.native.prevent="radioClick(item.id)"></van-radio>
          </div>
          <div class="address">
            <div class="text">地址</div>
            <div class="content">{{item.companyAddress}}</div>
          </div>
          <div class="address">
            <div class="text">电话</div>
            <div class="content">{{item.tel}}</div>
          </div>
          <div class="address">
            <div class="text">开户行</div>
            <div class="content">{{item.backName}}</div>
          </div>
          <div class="address">
            <div class="text">银行账号</div>
            <div class="content">{{item.backAcount}}</div>
          </div>
          <div class="address">
            <div class="text">收票人姓名</div>
            <div class="content">{{item.receiveName}}</div>
          </div>
          <div class="address">
            <div class="text">收票人联系方式</div>
            <div class="content">{{item.receiveTel}}</div>
          </div>
          <div class="address">
            <div class="text">收票人地址</div>
            <div class="content">{{item.receiveAddress}}</div>
          </div>

          <div class="caozuo">
            <span style="margin-left: 10px" @click="remove(item.id)">删除</span>
            <span @click="toPage(item.id)">修改</span>
          </div>
        </div>

      </van-radio-group>
      <div class="form-group" style="margin-top: 10px;line-height: 20px">
        发票内容说明：发票的内容和所购买的产品可能是同类产品内容，但如果该产品没有进项票的话，可以接受其他同类产品的发票内容。需要开原型号的发票的客户，请与客服联系。
      </div>
      <div class="footer">
        <div @click="backView" class="submit">保存</div>
        <div class="save" @click="$router.push({path:'/ticket'})">添加新发票信息</div>
      </div>

    </div>
  </div>
</template>

<script>
import { queryUserTicketList,deleteUserTicket } from '@/api/ticket/user.js'
export default {
  name: 'List',
  data() {
    return {
      currentItem: '',
      activeCoupon: '',
      activeCoupon1: '',
      isOnlinepay: 0,
      ticketList: []
    }
  },
  created() {
    this.isOnlinepay = this.$route.query.isOnlinepay
    this._queryUserTicketList()
  },
  methods: {
    radioClick (e) {
      e === this.activeCoupon1? (this.activeCoupon = '',this.activeCoupon1 = ''):(this.activeCoupon = e,this.activeCoupon1 = e)
    },
    remove(id){
      deleteUserTicket({id: id}).then(res=>{
        if (res.success){
          this.$toast.success("成功");
          this._queryUserTicketList()
        }
      })
    },
    toPage(id){
      this.$router.push({
        path: '/ticket',
        query: {
          id: id
        }
      })
    },
    // 发票列表
    _queryUserTicketList() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      const params = {
        uid: userInfo.id
      }
      if (this.isOnlinepay!=0){
        params.type = 0
      }
      queryUserTicketList(params).then((res) => {
        if (res.success) {
          this.ticketList = res.data
        }
      })
    },
    // 单选触发
    changeItem(value) {
      // this.currentItem = item
      if (!value){
        this.currentItem = ''
      }
      this.ticketList.forEach((item) => {
        if (item.id == value) {
          this.currentItem = item
        }
      })
    },
    // 保存
    backView() {
      if (!this.currentItem){
        this.$toast.fail("请选择");
        return
      }
      this.$route.params.item = this.currentItem
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    width: 100vw;
    height: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-y: scroll;
    font-size: 14px;
    background-color: #FFFFFF;
    .main{
      padding: 10px 12px;
      .title{
        height:22px;
        font-size:16px;
        font-weight:bold;
        line-height:22px;
        color:rgba(51,51,51,1);
        margin-bottom: 12px;
      }
      .item{
        /*height:188px;*/
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 2px rgba(0,0,0,0.16);
        padding: 10px;
        margin-bottom: 4px;
        .name{
          height:20px;
          font-size:14px;
          font-weight:bold;
          line-height:20px;
          color:rgba(51,51,51,1);
          text-align: center;
          /*padding-top: 20px;*/
        }
        .address{
          display: flex;
          flex-direction: row;
          margin-top: 8px;
          .text{
            text-align: justify;
            width:100px;
            height:20px;
            font-size:14px;
            font-weight:400;
            line-height:20px;
            color:rgba(136,137,136,1);
            margin-right: 23px;
          }
          .text:after{
            content:'.';
            width: 100%;
            display: inline-block;
            overflow: hidden;
            height: 0;
          }
          .content{
            flex: 1;
            font-size:14px;
            font-weight:400;
            line-height:20px;
            color:rgba(51,51,51,1);
          }
        }
        .caozuo{
          display: flex;
          flex-direction: row-reverse;
          margin-top: 5px;
        }
        .orderNo{
          display: flex;
          flex-direction: row;
          margin-top: 8px;
          .text{
            text-align: justify;
            width:100px;
            height:20px;
            font-size:14px;
            font-weight:400;
            line-height:20px;
            color:rgba(136,137,136,1);
            margin-right: 23px;
          }
          .text:after{
            content:'.';
            width: 100%;
            display: inline-block;
            overflow: hidden;
            height: 0;
          }
          .content{
            flex: 1;
            font-size:14px;
            font-weight:400;
            line-height:20px;
            color:rgba(51,51,51,1);
          }
        }
      }
      .footer{
        margin-top: 84px;
        /*position: fixed;*/
        /*left: 12px;*/
        /*right: 12px;*/
        /*bottom: 12px;*/
        .submit{
          height:40px;
          border:1px solid rgba(254,0,59,1);
          border-radius:4px;
          line-height:40px;
          text-align: center;
          background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
          color: #ffffff;
        }
        .save{
          height:40px;
          border:1px solid rgba(254,0,59,1);
          border-radius:4px;
          line-height:40px;
          text-align: center;
          margin-top: 20px;
          color: #333333;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ticket/list.vue